import moment from 'moment'

export const stringHumanize = (text = '') => {
	return text.replace( /_/g, ' ' ).replace( /(^|\s)[a-z]/g, (f) => f.toUpperCase() )
}

export const dateNow = () => moment().format( 'MM/DD/YYYY hh:mm a' )

export const yearNow = () => (new Date()).getFullYear().toString()

export const monthNow = () => ((new Date()).getMonth() + 1).toString()

export const formatDate = (date) => moment( date ).format( 'MM/DD/YYYY' )

export const getUserID = () => localStorage.getItem( 'user_id' )

export const userIs = (attribute, value = '') => {
	if ( attribute === 'sales_support_head' ) {
		return localStorage.getItem('is_sales_support_head')
	} else if ( attribute === 'dc' || attribute === 'collector' ) {
		return localStorage.getItem('role') === attribute
	} else if ( attribute === 'report' ) {
		const reports = JSON.parse( localStorage.getItem( 'available_reports' ) )
		return reports.indexOf( value ) !== -1
	}
	return false
}

export const getFirstDealership = () => {
	const dealerships = JSON.parse( localStorage.getItem( 'dealerships' ) )
	return dealerships && dealerships.length ? dealerships[0] : '';
}

export const isNumber = (n) => !isNaN(parseFloat(n)) && isFinite(n);

export const formatPeso = (num) => {
	if ( isNaN( num ) ) {
		return '–'
	}
	let fixedNum = num
	if ( num.replace ) {
		fixedNum = parseFloat( num.replace( /,/g, '' ) )
		if ( ! isNumber( fixedNum ) ) {
			return '–'
		}
	}
	return '₱' + fixedNum.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}

export const dateString = v => {
  let parsedDate = new Date(v);
  if ( isNaN(parsedDate) ) {
	  return;
  }
  let adjustedDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);

  return adjustedDate;
};

export const numberWithCommas = x => {
	var parts = x.toString().replace( /,/g, '' ).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

export const removeCommas = x => {
	return x.toString().indexOf(',') === -1 ? x : x.toString().replace( /,/g, '' )
}



// WEBPACK FOOTER //
// ./src/util.js